<div class="loader" [class]="loaderClass" data-testid="spinner">
  <div class="loader--spinner" [class]="spinnerClass"></div>
  <div class="loader--message">{{message}}</div>
</div>